export default {
  'text': {
    label: 'Textbox',
    value: 'text',
    attributes: [{
      name: 'isArea',
      value: false
    }]
  },
  'select': {
    label: 'Select',
    value: 'select',
    attributes: [{
      name: 'multiple',
      value: false
    }, {
      name: 'options',
      value: []
    }]
  },
  'number': {
    label: 'Number',
    value: 'number',
    attributes: [{
        name: 'min',
        value: 0
      },
      {
        name: 'max',
        value: 100
      },
    ]
  },
  'rating': {
    label: 'Rating',
    value: 'rating',
    attributes: []
  },
  datasource: {
    label: 'Datasource',
    value: 'datasource',
    attributes: [{
        name: 'datasourceId',
        value: null
      },
      {
        name: 'allowEdit',
        value: false
      },
      {
        name: 'allowCreate',
        value: false
      },
    ]
  }
}